import formatDate from '/functions/format-date';
import { createI18nInstance } from '/utilities/i18n';

const getT = () => createI18nInstance().t;

export const processWalletTransactions = (transactions) => {
  const t = getT();

  return (transactions ?? []).map(transaction => {
    const computedFields = (() => {
      if (transaction.type === 'CHARGE') {
        return {
          title: t('Para Yükleme'),
        };
      }

      if (transaction.type === 'SPENDING') {
        return {
          title: t('Alışveriş: {{merchantTitle}}', {
            merchantTitle: transaction.merchant?.title ?? t('Harcama'),
          }),
          expense: true,
        };
      }

      if (transaction.type === 'REFUND') {
        return {
          title: t('İade'),
          total_price: `${transaction.total_price}`,
          expense: true,
        };
      }

      if (transaction.type === 'TIP') {
        return {
          title: t('Bahşiş'),
          total_price: `${transaction.total_price}`,
          expense: true,
        };
      }

      return {
        title: transaction.type,
      };
    })();
    
    return {
      ...transaction,
      ...computedFields,
      formattedTimestamp: formatDate(transaction.created_at, 'd MMMM yyyy, HH:mm'),
    }
  });
}

export default processWalletTransactions;